"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Icon_1 = require("../../defaults/Icon");
var _helpers_1 = require("../../helpers");
var _styled_1 = require("../../styled-components");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var IconElement = styled_components_1.default(_styled_1.DefaultStyled)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  i {\n    color: ", ";\n\n    @media (max-width: ", ") {\n      color: ", ";\n    }\n\n    @media (max-width: ", ") {\n      color: ", ";\n    }\n\n    @media (max-width: ", ") {\n      color: ", ";\n    }\n\n    @media (max-width: ", ") {\n      color: ", ";\n    }\n    font-size: ", ";\n  }\n"], ["\n  i {\n    color: ",
    ";\n\n    @media (max-width: ", ") {\n      color: ",
    ";\n    }\n\n    @media (max-width: ", ") {\n      color: ",
    ";\n    }\n\n    @media (max-width: ", ") {\n      color: ",
    ";\n    }\n\n    @media (max-width: ", ") {\n      color: ",
    ";\n    }\n    font-size: ",
    ";\n  }\n"])), function (_a) {
    var defaultCss = _a.defaultCss, dark = _a.dark, theme = _a.theme;
    if (typeof dark === 'object') {
        return _helpers_1.setFontColor(dark.fullHd, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme);
    }
    return _helpers_1.setFontColor(dark, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme);
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointWidescreen;
}, function (_a) {
    var defaultCss = _a.defaultCss, dark = _a.dark, theme = _a.theme;
    if (typeof dark === 'object') {
        return _helpers_1.setFontColor(dark.widescreen, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme);
    }
    return _helpers_1.setFontColor(dark, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme);
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointDesktop;
}, function (_a) {
    var defaultCss = _a.defaultCss, dark = _a.dark, theme = _a.theme;
    if (typeof dark === 'object') {
        return _helpers_1.setFontColor(dark.desktop, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme);
    }
    return _helpers_1.setFontColor(dark, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme);
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointTablet;
}, function (_a) {
    var defaultCss = _a.defaultCss, dark = _a.dark, theme = _a.theme;
    if (typeof dark === 'object') {
        return _helpers_1.setFontColor(dark.tablet, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme);
    }
    return _helpers_1.setFontColor(dark, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme);
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointMobile;
}, function (_a) {
    var defaultCss = _a.defaultCss, dark = _a.dark, theme = _a.theme;
    if (typeof dark === 'object') {
        return _helpers_1.setFontColor(dark.mobile, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme);
    }
    return _helpers_1.setFontColor(dark, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme);
}, function (_a) {
    var size = _a.size;
    switch (size) {
        case 1:
            return '12px';
        case 2:
            return '16px';
        case 3:
            return '20px';
        case 4:
            return '24px';
        case 5:
            return '28px';
        case 6:
            return '32px';
        case 7:
            return '36px';
        case 8:
            return '40px';
        case 9:
            return '44px';
        case 10:
            return '48px';
        case 11:
            return '52px';
        case 12:
            return '56px';
        case 13:
            return '60px';
        default:
            return '1em';
    }
});
var BorderContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ", ";\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n  margin: 0 auto;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ",
    ";\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n  margin: 0 auto;\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor, dark = _a.dark, theme = _a.theme;
    return backgroundColor ? _helpers_1.setFontColor(dark, backgroundColor, theme) : 'none';
}, function (_a) {
    var width = _a.width;
    return (width ? width : 'auto');
}, function (_a) {
    var height = _a.height;
    return (height ? height : 'auto');
});
var Icon = function (_a) {
    var url = _a.url, dark = _a.dark, _b = _a.icon, icon = _b === void 0 ? Icon_1.defaultIconConfig.icon : _b, _c = _a.type, type = _c === void 0 ? Icon_1.defaultIconConfig.type : _c, _d = _a.size, size = _d === void 0 ? Icon_1.defaultIconConfig.size : _d, _e = _a.padding, padding = _e === void 0 ? Icon_1.defaultIconConfig.padding : _e, _f = _a.margin, margin = _f === void 0 ? Icon_1.defaultIconConfig.margin : _f, borderConfig = _a.borderConfig, defaultCss = _a.defaultCss, nativeProps = _a.nativeProps;
    return (react_1.default.createElement(IconElement, __assign({ dark: dark, size: size, padding: padding, margin: margin, defaultCss: defaultCss }, nativeProps),
        react_1.default.createElement(BorderContainer, __assign({}, borderConfig, { dark: dark }),
            type === 'material' && react_1.default.createElement("i", { className: "material-icons" }, icon),
            type === 'url' && react_1.default.createElement("img", { src: url, alt: "" }))));
};
exports.default = Icon;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Icon.js.map